import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  author, 
  ogTitle, 
  ogDescription, 
  ogImage, 
  ogUrl,
  canonicalUrl,
  noIndex = false,
  publishedTime,
  modifiedTime,
  schema,
  twitterCard = "summary_large_image" 
}) => {
  useEffect(() => {
    // Set document title
    if (title) {
      document.title = title;
    }

    // Helper function to update or create meta tags
    const updateMetaTag = (selector, attribute, content, property = false) => {
      if (!content) return;
      
      const attr = property ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${selector}"]`);
      
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attr, selector);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    // Basic Meta Tags
    updateMetaTag('description', 'content', description);
    updateMetaTag('keywords', 'content', keywords);
    updateMetaTag('author', 'content', author);

    // Robots
    if (noIndex) {
      updateMetaTag('robots', 'content', 'noindex, nofollow');
    } else {
      updateMetaTag('robots', 'content', 'index, follow');
    }

    // Open Graph
    updateMetaTag('og:type', 'content', 'article', true);
    updateMetaTag('og:title', 'content', ogTitle || title, true);
    updateMetaTag('og:description', 'content', ogDescription || description, true);
    updateMetaTag('og:image', 'content', ogImage, true);
    updateMetaTag('og:url', 'content', ogUrl, true);
    updateMetaTag('og:site_name', 'content', 'CloudVantage', true);
    updateMetaTag('article:published_time', 'content', publishedTime, true);
    updateMetaTag('article:modified_time', 'content', modifiedTime, true);

    // Twitter Card
    updateMetaTag('twitter:card', 'content', twitterCard);
    updateMetaTag('twitter:title', 'content', ogTitle || title);
    updateMetaTag('twitter:description', 'content', ogDescription || description);
    updateMetaTag('twitter:image', 'content', ogImage);
    updateMetaTag('twitter:site', 'content', '@CloudVantage');

    // Canonical URL
    if (canonicalUrl) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute('href', canonicalUrl);
      } else {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        canonicalLink.setAttribute('href', canonicalUrl);
        document.head.appendChild(canonicalLink);
      }
    }

    // JSON-LD Schema
    if (schema) {
      // Remove existing schema
      const existingSchema = document.querySelector('script[type="application/ld+json"]');
      if (existingSchema) {
        existingSchema.remove();
      }

      // Add new schema
      const schemaScript = document.createElement('script');
      schemaScript.type = 'application/ld+json';
      schemaScript.textContent = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }

    // Cleanup function
    return () => {
      // Optional: Remove tags when component unmounts
      // Usually not needed as they'll be updated by next page
    };
  }, [
    title, 
    description, 
    keywords, 
    author, 
    ogTitle, 
    ogDescription, 
    ogImage, 
    ogUrl,
    canonicalUrl,
    noIndex,
    publishedTime,
    modifiedTime,
    schema,
    twitterCard
  ]);

  // This component doesn't render anything visible
  return null;
};

export default SEO;

